import { makeStyles } from "@mui/styles";

export default makeStyles((theme) => ({
  title: {
    // marginTop: "2px !important",
    marginBottom: "10px !important",
    // paddingBottom: "25px !important",
    // marginLeft: "30px !important",
  },
  textfield: {
    "& label.Mui-focused": {
      color: "black",
    },
    "& .MuiFilledInput-underline:after": {
      borderBottomColor: "#5CB593",
    },
    "& .MuiOutlinedInput-root": {
      "&.Mui-focused fieldset": {
        borderColor: "#5CB593",
      },
    },
  },
  buttonText: {
    paddingLeft: "25px !important",
    paddingRight: "25px !important",
  },
  buttonOutlined: {
    // border: "1px solid #333333",
    // borderRadius: "20px",
    // opacity: 1,
    width: "150px",
    height: "40px",
  },
  tableHead: {
    font: "normal normal 600 15px/20px Nunito Sans",
    letterSpacing: "0px",
    color: "#212121",
    borderRightWidth: 1,
    borderColor: "#E8E8E8",
    borderTop: "1px solid #E8E8E8",
    padding:'8px !important'
  },
  tableContent: {
    // font: "normal normal normal 27px/38px Nunito Sans ",
    letterSpacing: "0px",
    // color: "#212121",
    borderColor: "#E8E8E8",
    borderRightWidth: 1,
    padding: "4px !important",
  },
  sampleButton: {
    borderRadius: "20px !important",
    //  backgroundColor: "#111",
    border: "1px solid #333 !important",
    // paddingLeft: "25px",
    // paddingRight: "25px",
    backgroundColor: "black !important",
    // width: "90%",
  },
  root: {
    backgroundColor: theme.palette.background.paper,
    // marginBottom: theme.spacing(2),
    paddingRight: "10px",
  },
  tab: {
    fontWeight: "800 !important",

    padding: "20px !important",
    "&.Mui-selected": {
      color: "#5CB593 !important",
    },
    "&:hover": {
      color: "#5CB593 !important",
    },
    "&:focus": {
      opacity: 1,
      color: "#5CB593 !important",
    },
  },
}));
